import { useEffect, useState } from 'react'
import {useParams} from 'react-router-dom'
import styled from 'styled-components'
import { IRoleRecord } from '../type'
import { useQueryRoles } from '../api/roles'
import { useQueryTeams } from '../api/teams'
import { useQueryUserDetails, useUpdate } from '../api/users'
import { List } from './List'

const Wrapper = styled.div`
  & select {
    width: 100%;
    min-height: 3rem;
    padding: .5rem;
    margin-bottom: 2rem;
    outline: 1px solid hsl(30, 60%, 80%);
  }
`
export default function UserDetails() {
  const [selectedItemsUUID, setSelectedItemsUUID] = useState<string[]>([])
  const [currentTeamUUID, setCurrentTeamUUID] = useState<string>('')
  const {uuid} = useParams()
  const { mutate: update } = useUpdate()
  const { data: teams } = useQueryTeams()
  const { data: roles } = useQueryRoles()
  const { data: details } = useQueryUserDetails({ uuid })
  // console.log(roles)
  // console.log(details)
  // console.log(teams)

  useEffect(() => {
    if (!!details?.roles) {
      setSelectedItemsUUID(
        details.roles.map(
          (x:IRoleRecord) => x.id
        )
      )
    }
  }, [roles, details])
  useEffect(() => {
    if (!!teams?.[0]?.id) {
      setCurrentTeamUUID(teams[0].id)
    }
  }, [teams])

  const onItemClick = (id:string) => {
    if (!id) return

    const newroles = (selectedItemsUUID.includes(id)) ?
      [ ...selectedItemsUUID.filter((x:string) => x!==id) ]
      :
      [ ...selectedItemsUUID, id]
    ;
    setSelectedItemsUUID([...newroles])
    update({
      userId: uuid,
      roles:newroles,
    })
  }

  const onChange = (e:any) => {
    if (!!e?.target?.value) {
      setCurrentTeamUUID(e.target.value)
    }
  }

  const matchedRoles = roles?.filter(
    (r:any) => (r.teamId===currentTeamUUID)
  ).sort(
    (a:IRoleRecord, b:IRoleRecord) => ((a.sort < b.sort) ? -1:1) 
  )
  return (
    <Wrapper>
      { !!teams?.length ?
        <select value={currentTeamUUID}
          onChange={onChange}
        >
        { teams.map((t:any) => (
          <option key={t.id} value={t.id} >
            {t.name}-[{t.type}]
          </option>
        )) }
        </select>
        :
        <h1>No teams found!</h1>
      }
      { !!matchedRoles?.length ?
        <List keys={['name', 'displayName', 'id']}
          selectedItemsId={selectedItemsUUID}
          items={matchedRoles}
          onItemClick={onItemClick}
        />
        :
        <h1>No matched role!</h1>
      }
    </Wrapper>
  )
}
